import React, { useState, useEffect } from "react";
import ReactDom from "react-dom";
import { useAppSelector } from "../../Redux/app/hooks";
import { buySellAmount, formatNumber } from "../../helpers/helper";

function EQSOrderConfirmationDetail({conValue, confirm, bid_value, userType, selectedPortfolios,allocate_portfolio }: any) {
  const form = useAppSelector((state) => state.orderSection.form_data);
  const default_security_set: any = useAppSelector((state) => state.dashBoard.default_security_set);
 
  return (
    <>
      <div className="order-confirmation-table">
        <table>
          <thead>
            <tr>
              <th>Description</th>
              <th>Transaction</th>
              <th>Type</th>
              <th>Duration</th>
              <th>Price</th>
              <th>Quantity</th>
              { userType === "internal_destributor" && <th>Est. Markup</th>}
              <th>Est. Total</th>
            </tr>
          </thead>
          <tbody>
            <tr className={`${form.direction.toLowerCase() === "buy" ? "buy" : "sell"}-row`}>
              <td>
                <span>{confirm.security_name}</span>
                <div className="tooltiptext">
                  <p>{confirm.security_name}</p>
                </div>
              </td>
              <td>{form.direction.toUpperCase()}</td>
              <td>{form.order_type === "stop_limit" ? "STOP LIMIT" : form.order_type.toUpperCase()}</td>
              <td>
                <span>{confirm.time.replace(/_/g, " ")}</span>
              </td>
              <td>
                <>
                  {bid_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
                    <b>N/A</b>
                  ) : (
                    <>{form.direction.toLowerCase() === "sell" && <b>{Number(confirm.price).toFixed(2)}</b>}</>
                  )}
                </>
              </td>
            
              <td>
                {!conValue ? (
                  <b>{formatNumber(confirm.quantity)}</b>
                ) : (
                  <b>
                    {formatNumber(confirm.quantity)} (Lot size 1 = {new Intl.NumberFormat().format(conValue?.Multiplier)})
                  </b>
                )}
              </td>
              {
                (userType === "internal_destributor") && (
                  <td>
                    <b>0</b>
                  </td>
                )
              }
              <td className="w-[120px]">
                {bid_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
                  <b>N/A</b>
                ) : (
                  <>
                    {!conValue ? (
                      <>
                        {form.direction.toLowerCase() === "sell" && (
                          <>
                         
                         { userType === "internal_destributor" ? <b>
                            ({new Intl.NumberFormat().format(confirm.quantity * confirm.price)}) {confirm.currency ? confirm.currency : default_security_set.currency}
                          </b> : <b>
                            {new Intl.NumberFormat().format(confirm.quantity * confirm.price)} {confirm.currency ? confirm.currency : default_security_set.currency}
                          </b>}
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {form.direction.toLowerCase() === "sell" && (
                          <>
                          { userType === "internal_destributor" ? <b>
                            ({new Intl.NumberFormat().format(confirm.quantity * confirm.price * conValue?.Multiplier)}) {confirm.currency ? confirm.currency : default_security_set.currency}
                            </b> : <b>
                              {new Intl.NumberFormat().format(confirm.quantity * confirm.price * conValue?.Multiplier)} {confirm.currency ? confirm.currency : default_security_set.currency}
                            </b>}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </td>
            </tr>
               {/* For client information */}
               {userType === "internal_destributor" &&
              selectedPortfolios.map(
                (allocates_input: any, index: any) =>
                  allocates_input.client_id !== null &&
                  Number(allocates_input.client_id) !== 0 && allocates_input.est_markup !== 0 && (
                    <tr key={`EMFI-${allocates_input.client_id}`} className={`${form.direction.toLowerCase() === "buy" ? "sell" : "buy"}-row `}>
                    <td className={"td-text-indent"}>
                    {allocate_portfolio.filter((option: any) => option?.counterparty_id == selectedPortfolios[index]?.client_id)[0]?.title} </td>
                    {userType === "internal" && <td>{form.direction.toUpperCase() === "BUY" ? "SELL" : "BUY"}</td> }
                 
                  {userType === "internal_destributor" && <td>{form.direction.toUpperCase() === "BUY" ? "SELL" : "BUY"}</td> }
                    <td>{form.order_type.toUpperCase()}</td>
                    <td>{confirm.time.replace(/_/g, " ")}</td>
                    <td>
                    <b className="width-100">{Number(allocates_input.markup_price).toFixed(3)}</b>
                    </td>
                    <td>
                      {!conValue ? (
                        <b>{formatNumber(allocates_input.qty)}</b>
                      ) : (
                        <b>
                          {formatNumber(allocates_input.qty)} (Lot size 1 = {new Intl.NumberFormat().format(conValue?.Multiplier)})
                        </b>
                      )}
                    </td>
                    {(userType === "internal_destributor") && (
                      <td>
                        <b>{allocates_input.est_markup}</b>
                      </td>
                    )}
                    
                    <td>
                    <b className="width-100">
                              {formatNumber(allocates_input.inverse_currency_amt_display)} {confirm.currency ? confirm.currency : default_security_set.currency}
                            </b>
                    </td>
                  </tr>
                  )
              )}
          </tbody>
        </table>
        <>
          {bid_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
            <></>
          ) : (
            <>
              {!conValue ? (
                <>
                  {form.direction.toLowerCase() === "sell" && (
                    <p>
                      At a price of {confirm.price !== 0 ? Number(confirm.price).toFixed(2) : ""} per share, the value of this trade is estimated at{" "}
                      {new Intl.NumberFormat().format(confirm.quantity * confirm.price)} {confirm.currency ? confirm.currency : default_security_set.currency}
                    </p>
                  )}
                </>
              ) : (
                <>
                  {form.direction.toLowerCase() === "sell" && (
                    <p>
                      At a price of {confirm.price !== 0 ? Number(confirm.price).toFixed(2) : ""} per share, the value of this trade is estimated at{" "}
                      {new Intl.NumberFormat().format(confirm.quantity * confirm.price * conValue?.Multiplier)} {confirm.currency ? confirm.currency : default_security_set.currency}
                    </p>
                  )}
                </>
              )}
          </>
          )}
        </>
      </div>
    </>
  );
}

export default EQSOrderConfirmationDetail;
